/* global axios */
// NOTICE: KAPTION-INTEGRATION - whatsapp-flows: Rumo flow library, responses,
// export and in-chat sends. Routes follow the cross-repo contract; every route
// answers 404 while KAPTION_WHATSAPP_FLOWS is off for the account.
import ApiClient from './ApiClient';

class KaptionWhatsappFlowsAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  flowsUrl(inboxId) {
    return `${this.url}/${inboxId}/whatsapp_flows`;
  }

  list(inboxId, params = {}) {
    return axios.get(this.flowsUrl(inboxId), { params });
  }

  show(inboxId, flowId) {
    return axios.get(`${this.flowsUrl(inboxId)}/${flowId}`);
  }

  sync(inboxId) {
    return axios.post(`${this.flowsUrl(inboxId)}/sync`);
  }

  readiness(inboxId) {
    return axios.get(`${this.flowsUrl(inboxId)}/readiness`);
  }

  preview(inboxId, flowId, version = 'published') {
    return axios.get(`${this.flowsUrl(inboxId)}/${flowId}/preview`, {
      params: { version },
    });
  }

  responses(inboxId, flowId, params = {}) {
    return axios.get(`${this.flowsUrl(inboxId)}/${flowId}/responses`, {
      params,
    });
  }

  exportResponses(inboxId, flowId, data) {
    return axios.post(
      `${this.flowsUrl(inboxId)}/${flowId}/responses/export`,
      data
    );
  }

  exportStatus(inboxId, exportId) {
    return axios.get(`${this.flowsUrl(inboxId)}/exports/${exportId}`);
  }

  // In-chat interactive flow message (24h window).
  sendInConversation(conversationId, data) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/whatsapp_flow_messages`,
      data
    );
  }
}

export default new KaptionWhatsappFlowsAPI();
